/**
 *
 */
export enum PagewebPage {
  BuyTicket = 'BuyTicket',
  Main = 'Main',
  OpenMain = 'OpenMain',
  Subtab = 'Subtab',
  Content = 'Content',
  Viewer = 'Viewer',
  SetOverview = 'SetOverview',
  InvenRecent = 'InvenRecent',
  InvenLike = 'InvenLike',
  InvenPaid = 'InvenPaid',
  Notice = 'Notice',
  NoticeWithId = 'NoticeWithId',
  AppStore = 'AppStore',
  LandingSeriesList = 'LandingSeriesList',
  LandingSingleList = 'LandingSingleList',
  LandingSeriesPoster = 'LandingSeriesPoster',
  LandingSeriesListWithTheme = 'LandingSeriesListWithTheme',
  LandingSingleListWithTheme = 'LandingSingleListWithTheme',
  LandingSeriesPosterWithTheme = 'LandingSeriesPosterWithTheme',
  LandingSetList = 'LandingSetList',
  LandingSetPoster = 'LandingSetPoster',
  LandingTodayNew = 'LandingTodayNew',
  LandingTodayNewSubcategory = 'LandingTodayNewSubcategory',
  LandingTodayUp = 'LandingTodayUp',
  LandingTodayUpSubcategory = 'LandingTodayUpSubcategory',
  LandingOriginal = 'LandingOriginal',
  LandingOriginalSubcategory = 'LandingOriginalSubcategory',
  LandingEventTotal = 'LandingEventTotal',
  LandingEvent = 'LandingEvent',
  LandingRankingSubcategory = 'LandingRankingSubcategory',
  LandingRanking = 'LandingRanking',
  LandingRankingTheme = 'LandingRankingTheme',
  LandingGenre = 'LandingGenre',
  LandingGenreSubcategory = 'LandingGenreSubcategory',
  Dayofweek = 'Dayofweek',
  DayofweekSubcategory = 'DayofweekSubcategory',
  Freeseries = 'Freeseries',
  WebviewEvent = 'WebviewEvent',
  Gacha = 'Gacha',
  Redeem = 'Redeem',
  TodayGiftList = 'TodayGiftList',
  TodayGiftListWithCategory = 'TodayGiftListWithCategory',
  Comments = 'Comments',
  CommentsDetail = 'CommentsDetail',
  SpecialGift = 'SpecialGift',
  MyNews = 'MyNews',
  MyNewsWithTab = 'MyNewsWithTab',
  /**
   @deprecated
   아직 미지원
   */
  BuyCash = 'BuyCash',
  CashHistory = 'CashHistory',
  TicketHistory = 'TicketHistory',
  Cashfriends = 'Cashfriends',
  /** @deprecated */
  KeytalkSearch = 'KeytalkSearch',
  /**
   * @deprecated
   * 아직 미지원
   */
  CashSponsor = 'CashSponsor',
  Autocharge = 'Autocharge',
  SearchMain = 'SearchMain',
  SearchSeries = 'SearchSeries',
  SearchFilter = 'SearchFilter',
  /** @deprecated */
  SearchKeytalk = 'SearchKeytalk',
}
